<template>
	<div class="hiq-article-list__message hiq-search-message">
    <p class="hiq-article-list__message-text hiq-search-message__text"
      aria-live="polite"
      v-if="total >= 0 && !loading">
        Listan innehåller {{ total }} objekt.
    </p>
	</div>
</template>

<script lang="ts">
import Vue from 'vue';

interface ArticleMessageComputed {
  total: number;
  loading: boolean
}

export default Vue.extend<{}, {}, ArticleMessageComputed, {}>({
	name: 'ArticleMessage',
	computed: {
    total() {
      return this.$store.getters.total;
    },
    loading() {
      return this.$store.getters.loading;
    }
	},
	components: {

	}
})
</script>
